import { all, delay } from 'redux-saga/effects';

export function* throttleEffect(effect: any, delayTime: number = 500): any {
  const [effectPayload] = yield all([effect, delay(delayTime)]);

  return effectPayload;
}
